import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';

const WrapDiv = styled.div`
  position: relative;
  & button {
    box-shadow: none;
    text-shadow: none;
    cursor: pointer;
  }
  & input {
    min-width: 115px;
    height: 38px;
    background-color: #ffffff;
    color: #1E2228;
    font-size: 14px;
    font-weight: 400;
    border-radius: 6px;
    border: 1px solid #c9c9c9;
    margin: 0px;
    padding: 13px 35px 13px 15px;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
`;
const List = styled.div`
  max-height: 50vh;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 4;
  border-radius: 4px;
  border: 1px solid #E6E6E6;
`;
const ListItem = styled.button`
  min-width: 115px;
  background-color: #ffffff;
  color: #1E2228;
  font-size: 14px;
  border-bottom: 1px solid #E6E6E6;
  padding: 8px 15px;
  margin: 0px;
  display: flex;
  white-space: nowrap;
  &:hover {
    background-color: #f6f6f6;
  }
`;
const InfoDiv = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: #939599;
  margin-top: 8px;
`;
const SelectedWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
`;
const SelectedDiv = styled.div`
  height: 26px;
  font-size: 12px;
  padding: 0px 10px 0px 10px;
  background-color: #EFEFF0;
  margin: 4px 8px 4px 0px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  cursor: pointer;
  & span {
    height: 12px;
    width: 12px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    &:before {
      content: '';
      height: 1px;
      width: 10px;
      background-color: #888888;
      position: absolute;
      transform: rotate(45deg);
    }
    &:after {
      content: '';
      height: 1px;
      width: 10px;
      background-color: #888888;
      position: absolute;
      transform: rotate(-45deg);
    }
  }
`;

const InputSuggestion = (props) => {
  const { placeholder, list, name, value, width, height, option, active, error, info, selected, change, remove } = props;
  const wrapperRef = useRef(null);
  const [listOpen, setListOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (wrapperRef && !wrapperRef.current.contains(event.target)) {
      setListOpen(false);
    }
  }

  const selectItem = (item) => {
    setListOpen(false);
    selected(name, item);
    if (typeof props.showLast !== 'undefined') {
      // change(name, item);
      setInputValue(item);
    } else {
      setInputValue('');
    }
  }

  const changeItem = (e) => {
    if (typeof e !== 'undefined' && typeof e.target !== 'undefined' && typeof e.target.value !== 'undefined') {
      const value = e.target.value;
      setInputValue(value);
      change(name, value);
      if (value.length >= 1) {
        setListOpen(true);
      } else {
        setListOpen(false);
      }
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>

      <WrapDiv style={{ width: width, height: height }} ref={wrapperRef}>
        <input
          placeholder={placeholder}
          style={error ? { width: width, height: height, border: '1px solid #E74C3C' } : { width: width, height: height }}
          onChange={(e) => changeItem(e)}
          value={inputValue}
        >
        </input>

        { listOpen && list && list.length > 0 ?
          <List>
            { list.map((item, itemIndex) => {
              let isActive = false;
              if (active && active.includes(item[option])) {
                isActive = true;
              }
              return (
                <ListItem
                  key={`${item[option]}_${itemIndex}`}
                  onClick={() => selectItem(item[option])}
                  style={{ minWidth: width, fontWeight: isActive ? '700' : 'normal' }}
                >
                  {item[option]}
                </ListItem>
              )
            })}
          </List>
        : ''
        }
      </WrapDiv>

      { info && info !== '' ?
        <InfoDiv>{info}</InfoDiv>
      : ''
      }

      { typeof info !== 'undefined' && active && active.length > 0 ?
        <SelectedWrap>
          { active.map((s, sIndex) => (
            <SelectedDiv key={`suggestion_${s}`} onClick={() => remove(name, sIndex)}>{s}<span /></SelectedDiv>
          )) }
        </SelectedWrap>
      : ''
      }

    </div>
  );
}

export default InputSuggestion;